import React from 'react';
import { renderRich } from '../utils/richText';
type NoticeProps = {
  text: string;
  tone?: 'accent' | 'ok';
};
export function Notice({
  text,
  tone = 'accent'
}: NoticeProps) {
  const toneClass = tone === 'ok' ? 'border-ok/30 border-l-ok bg-ok/[0.06]' : 'border-accent/30 border-l-accent bg-accent/[0.06]';
  return <div className={`my-6 rounded-[10px] border border-l-[3px] px-[18px] py-4 text-[14.5px] leading-relaxed text-[#e2e2e8] ${toneClass}`} data-id="element-81" data-mp="2yhxooyie8m2l">
      {renderRich(text)}
    </div>;
}